



















































import CommonBase from "../CommonBase";
import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import Api from "./Api";
import {ApiMessage, DateTime, PendingCardReply, PhoneNumber} from "../../modules/models";
import HmsCardDisplay from "../HmsCardDisplay.vue";
import PhoneAddIcon from "../PhoneAddIcon.vue";
import {phoneCheckedLocation} from "@/modules/LoginFlow";
import {ignoreRedundantNavErr} from "@/router";
import Recaptcha from "@/components/prelogin/Recaptcha.vue";

// Possible scenarios to handle:
// - ApiMessage returned. => display it
// - The card is already registered on some user. (reply.nextOp <> ADD_NEW) => Show info text (allow takeover??)
// - New card, ready for signup. => show info text
//
//  If invalid, or other error, display error message and direct back to login.
//  If Card is already registered on user, ask if user wants to add given phone number to it by confirming ownership. Display also other phone numbers attached to existing user, if any.
//  If Card is not registered before, ask if user wants to create user by confirming phone ownership.
//
// If user wants to confirm ownership:
// Do the same procedure as when user inputs phone number and scans card on terminal to get phonenumber attached.
// (TerminalApi.phoneAuthorize)
// If card is not registered before:
//      Add card and person created from card, just like when card is first registered on a terminal.
//
// Check that it's not invalid or expired -> Display error message if so
// Get attached person
// Check that phone is not already registered. Abort with error if so (unlike the terminal phone auth flow)
// Insert pending_id_card_passcode row (phoneConfirmHelper.pendingIdCardPhoneInsert)
@Component({
    components: {
      "at-card-display": HmsCardDisplay,
      "at-phone-add-icon": PhoneAddIcon,
      "at-recaptcha": Recaptcha,
    }
})
export default class SignupVerified extends CommonBase {
    @Inject()
    api!: Api;
    @Prop()
    phone!: PhoneNumber;
    @Prop()
    cardnum!: number;
    @Prop({default: ""})
    redir!: string;

    ALREADY_CONNECTED = PendingCardReply.ALREADY_CONNECTED;
    ADD_NEW = PendingCardReply.ADD_NEW;
    MERGE = PendingCardReply.MERGE;
    TAKEOVER = PendingCardReply.TAKEOVER;

    fetching = false;
    reply: PendingCardReply | null = null;
    errMsg: ApiMessage | null = null;
    recaptchaApproved = false;

    get card() {
        return this.reply != null && this.reply.card != null ? this.reply.card : null;
    }
    get otherPerson() {
        return this.reply != null && this.reply.otherPerson != null ? this.reply.otherPerson : null;
    }
    get otherPersonPhones(): PhoneNumber[] {
        return this.reply != null && this.reply.otherPersonPhones != null ? this.reply.otherPersonPhones : [];
    }
    get otherPersonPhonesList(): string {
        return this.otherPersonPhones.join(", ");
    }

    get sendDisabled() {
        return !this.recaptchaApproved || this.fetching || this.errMsg != null || this.reply == null || (this.reply.nextOp != this.ADD_NEW && this.reply.nextOp != this.TAKEOVER);
    }

    onRecaptchaChecked(v: boolean) {
      this.recaptchaApproved = v;
    }

    @Watch("cardnum", {immediate: true})
    async onCardNumChanged() {
        this.fetching = true;
        try {
            const res = await this.api.pendingCard(this.cardnum);
            if(res instanceof ApiMessage) {
                this.reply = null;
                this.errMsg = res;
            } else {
                this.reply = res;
                this.errMsg = null;
            }
        } finally {
            this.fetching = false;
        }
    }

    sending = false;
    async send() {
        try {
            this.sending = true;
            let msg: ApiMessage;
            if(this.reply != null && this.card != null) {
                if (this.reply.nextOp === this.ADD_NEW) {
                    msg = await this.api.pendingCardPersonAdd(this.phone, this.card.cardNum);
                } else if (this.reply.nextOp === this.TAKEOVER) {
                    msg = await this.api.pendingCardPhoneConnect(this.phone, this.card.cardNum);
                } else {
                    throw `Invalid nextOp (${this.reply.nextOp})`;
                }
                if (msg.num == 16) { // SMS sent ok
                    this.snack(`Logg inn med kode eller link mottatt på SMS.`);
                    // Redirect to login page, without doing phone check since we know pending code was just created.
                    const pendingCreated = DateTime.now().millis().toString();
                    await ignoreRedundantNavErr(this.$router.push(phoneCheckedLocation(this.phone, pendingCreated, undefined, this.redir)));

                } else {
                    this.errMsg = msg;
                }
            } else {
                this.snack(`HMS-kort ikke funnet, kan ikke verifisere`);
            }
        } finally {
            this.sending = false;
        }
    }

    snack(txt: string) {
        this.$emit("at-snack", txt);
    }

}
